import { ChangeEvent, useState } from "react";

import { useTranslation } from "react-i18next";

import { isNumeric } from "@/components/PageHeader/actions/functions";
import { USER_INFO_ERROR_KEYS } from "@/shared";

export const useValidateOtp = () => {
  const { t } = useTranslation();

  const [errorKey, setErrorKey] = useState<string | null>(null);

  const validateOtp = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = event.target.value.trim();

    if (value && !isNumeric(value)) {
      return setErrorKey(USER_INFO_ERROR_KEYS.NumbersOnly);
    }

    return setErrorKey("");
  };

  return {
    error: errorKey ? t(errorKey) : null,
    setError: setErrorKey,
    validateOtp
  };
};
